import FlatCard from 'components/common/flatCard/FlatCard'
import FlatCardHeader from 'components/common/flatCard/FlatCardHeader'
import FlatCardTitle from 'components/common/flatCard/FlatCardTitle'
import IconRender from 'components/common/IconRender'
import { useState } from 'react'
import { CustomColorsRef, IconSizes } from 'types/general'

interface Label {
  tag_id: string
  label: string
  left_icon: string
  category?: string
}

const TagsList = ({
  label,
  icon,
  currentTags,
  allTags,
  handleAddTag,
}: {
  label: string
  icon: string
  currentTags: Label[]
  allTags?: Label[]
  handleAddTag?: (category: string, tagId: string) => void
}) => {
  const [showTagPicker, setShowTagPicker] = useState(false)

  const availableTags = allTags?.filter(
    tag => !currentTags.find(t => t.tag_id === tag.tag_id)
  )

  return (
    <div className="relative my-4">
      {showTagPicker && availableTags && availableTags.length > 0 && (
        <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-md mb-2 p-3 grid grid-cols-1 sm:grid-cols-3 gap-2">
          {availableTags.map(tag => (
            <button
              key={tag.tag_id}
              onClick={() => {
                if (currentTags[0]?.category) {
                  handleAddTag?.(currentTags[0].category, tag.tag_id)
                  setShowTagPicker(false)
                }
              }}
              className="flex items-center gap-2 px-3 py-2 rounded-md bg-gray-50 hover:bg-gray-100 text-sm text-gray-700 border border-gray-200"
            >
              <IconRender
                icon={tag.left_icon}
                size={IconSizes.MD}
                color={CustomColorsRef.Primary}
              />
              {tag.label}
            </button>
          ))}
        </div>
      )}

      <FlatCard>
        <FlatCardHeader>
          <FlatCardTitle>
            <IconRender
              icon={icon}
              size={IconSizes.LG}
              color={CustomColorsRef.Primary}
            />
            {label}
          </FlatCardTitle>
        </FlatCardHeader>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {currentTags.map(({ tag_id, label, left_icon }, index) => (
            <div
              key={`${tag_id}-${index}`}
              className="flex items-center gap-2 px-4 py-2 rounded-md bg-gray-100 text-sm text-gray-800"
            >
              <IconRender
                icon={left_icon}
                size={IconSizes.MD}
                color={CustomColorsRef.Primary}
              />
              {label}
            </div>
          ))}
          {availableTags?.length && (
            <button
              onClick={() => setShowTagPicker(prev => !prev)}
              className="flex items-center justify-center gap-2 px-4 py-2 rounded-md border-2 border-dashed border-gray-300 text-sm text-gray-500 hover:border-primary hover:text-primary transition-colors"
            >
              <IconRender
                icon="regular-plus"
                size={IconSizes.MD}
                color={CustomColorsRef.Primary}
              />
              Add Tag
            </button>
          )}
        </div>
      </FlatCard>
    </div>
  )
}

export default TagsList
